import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Context from '../../../utils/context';
import Typography from '../../core/ui/typography';

import styles from './v2.module.css';

export default function PostSurveyThankYouV2() {
  const context = useContext(Context);
  const homePath = context.auth.isLoggedIn() ? '/member/conversations' : '/member/login';

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <span className={styles.icon_glow} aria-hidden='true' />
          <span className={styles.icon_circle}>
            <svg className={styles.icon_check} viewBox='0 0 24 24' fill='none' aria-hidden='true'>
              <path
                d='M20 6 9 17l-5-5'
                stroke='#ffffff'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </span>
        </div>
        <Typography as='h1' variant='heading4xl' align='center' className={styles.title}>
          Thank you!
        </Typography>
        <Typography variant='bodyLg' align='center' color='var(--text-secondary)' className={styles.message}>
          Your feedback is invaluable to us. With it, we can continue to improve the platform and experience for
          patients everywhere.
        </Typography>
        <Typography
          variant='uiSm'
          align='center'
          color='var(--text-tertiary)'
          className={styles.caption}
          style={{ fontFamily: 'var(--font-body)' }}
        >
          Your responses go to the team — never to your mentor.
        </Typography>
        <Link to={homePath} className={styles.home_link}>
          <button type='button' className={styles.home_button}>
            Home
          </button>
        </Link>
      </div>
    </div>
  );
}
